import "core-js/modules/es.array.map.js";
import React from 'react';
import { ArticleListItem } from '../ArticleListItem';
import { SectionTitle } from '../SectionTitle';
export var ArticleList = function ArticleList(_ref) {
  var articles = _ref.articles,
    onAction = _ref.onAction;
  return React.createElement("div", null, React.createElement(SectionTitle, null, "Paso a paso"), React.createElement("div", null, articles.map(function (article, index) {
    return React.createElement(ArticleListItem, {
      key: index,
      article: article,
      onAction: onAction
    });
  })));
};